import { CustomDetector } from 'i18next-browser-languagedetector';
import { I18Language } from './i18n.types';
import { BusinessUnit, getBusinessUnit } from '../utils/business.utils';

const defaultBusinessUnitLanguages: Record<
	BusinessUnit,
	I18Language | undefined
> = {
	Noordhoff: 'nl-NL',
	Plantyn: 'nl-BE',
	Liber: 'sv'
};

const i18nBusinessUnitLanguageDetector: CustomDetector = {
	name: 'businessUnitLanguageDetector',
	lookup: () => {
		const {
			location: { hostname }
		} = window;
		if (hostname === 'localhost') return 'dev';

		const businessUnit = getBusinessUnit();
		if (!businessUnit) return undefined;
		return defaultBusinessUnitLanguages[businessUnit];
	}
};

export default i18nBusinessUnitLanguageDetector;
